import React from 'react';
import DocumentReader from './DocumentReader';
import { documentTitle, documentSlug, parts } from './content/craftStructureReference';

export default function CraftStructureReference() {
  return (
    <DocumentReader
      documentId={documentSlug}
      title={documentTitle}
      intro="Quick-lookup facts and checklists for Craft and Structure — passage structures, contrast/continuation signal words, and the words-in-context and cross-text methods."
      parts={parts}
    />
  );
}
